export default __webpack_public_path__ + "static/media/arrow2_left_white.9de95626.svg";